module.exports = __webpack_public_path__ + "img/yyjc.b543cdab.png";